import {
  type ChainIdParameter,
  type ChainType,
  type ClientType,
  type EVMChain,
} from '@particle-network/connector-core';
import { getClient } from '../actions/getClient';
import { useContext } from '../context';

export function usePublicClient<chainType extends ChainType = EVMChain>(
  parameters: ChainIdParameter = {}
): ClientType<chainType> | null {
  const { chainId } = parameters;
  const { config } = useContext();

  return getClient(config, { chainId });
}
